import React from 'react';
import styles from '../OrderList.module.css';

function OTPFilter({ OrderD, OrderCal, loading }) {
    return (
        <div className={styles['shopify-stats-section']}>
            <div className={styles['stats-cards']}>
                {loading ? (
                    <>
                        {[1, 2, 3].map((n) => (
                            <div key={n} className={styles['stat-card']}>
                                <div className={`${styles.skeleton}`} style={{ width: 40, height: 40, borderRadius: 8, flexShrink: 0 }}></div>
                                <div className={styles['stat-content']}>
                                    <div className={`${styles.skeleton}`} style={{ width: 80, height: 22, marginBottom: 6 }}></div>
                                    <div className={`${styles.skeleton}`} style={{ width: 100, height: 14 }}></div>
                                </div>
                            </div>
                        ))}
                    </>
                ) : (
                    <>
                        <div className={styles['stat-card']}>
                            <div className={styles['stat-icon']}>
                                <svg width="20" height="20" viewBox="0 0 20 20" fill="currentColor">
                                    <path d="M3 4a1 1 0 011-1h12a1 1 0 011 1v2a1 1 0 01-1 1H4a1 1 0 01-1-1V4zM3 10a1 1 0 011-1h6a1 1 0 011 1v6a1 1 0 01-1 1H4a1 1 0 01-1-1v-6zM14 9a1 1 0 00-1 1v6a1 1 0 001 1h2a1 1 0 001-1v-6a1 1 0 00-1-1h-2z" />
                                </svg>
                            </div>
                            <div className={styles['stat-content']}>
                                <div className={styles['stat-value']}>{OrderD.length}</div>
                                <div className={styles['stat-label']}>Total Orders</div>
                            </div>
                        </div>

                        <div className={styles['stat-card']}>
                            <div className={styles['stat-icon']}>
                                <svg width="20" height="20" viewBox="0 0 20 20" fill="currentColor">
                                    <path d="M8.433 7.418c.155-.103.346-.196.567-.267v1.698a2.305 2.305 0 01-.567-.267C8.07 8.34 8 8.114 8 8c0-.114.07-.34.433-.582zM11 12.849v-1.698c.22.071.412.164.567.267.364.243.433.468.433.582 0 .114-.07.34-.433.582a2.305 2.305 0 01-.567.267z" />
                                    <path fillRule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zm1-13a1 1 0 10-2 0v.092a4.535 4.535 0 00-1.676.662C6.602 6.234 6 7.009 6 8c0 .99.602 1.765 1.324 2.246a4.535 4.535 0 001.676.662V9a1 1 0 112 0v.092a4.535 4.535 0 001.676-.662C13.398 9.765 14 8.99 14 8c0-.99-.602-1.765-1.324-2.246A4.535 4.535 0 0011 5.092V5z" clipRule="evenodd" />
                                </svg>
                            </div>
                            <div className={styles['stat-content']}>
                                <div className={styles['stat-value']}>৳{OrderCal.taka?.toLocaleString() || 0}</div>
                                <div className={styles['stat-label']}>Total Amount</div>
                            </div>
                        </div>

                        <div className={styles['stat-card']}>
                            <div className={styles['stat-icon']}>
                                <svg width="20" height="20" viewBox="0 0 20 20" fill="currentColor">
                                    <path fillRule="evenodd" d="M3 3a1 1 0 000 2v8a2 2 0 002 2h2.586l-1.293 1.293a1 1 0 101.414 1.414L10 15.414l2.293 2.293a1 1 0 001.414-1.414L12.414 15H15a2 2 0 002-2V5a1 1 0 100-2H3zm11.707 4.707a1 1 0 00-1.414-1.414L10 9.586 8.707 8.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z" clipRule="evenodd" />
                                </svg>
                            </div>
                            <div className={styles['stat-content']}>
                                <div className={styles['stat-value']}>৳{OrderCal.Profit?.toLocaleString() || 0}</div>
                                <div className={styles['stat-label']}>Total Profit</div>
                            </div>
                        </div>
                    </>
                )}
            </div>
        </div>
    );
}

export default OTPFilter;
